import { createContext } from 'react';

export const PieChartLoadingContext = createContext<boolean | undefined>(
  undefined,
);
